<div class="tw:flex tw:flex-col">
  @if (!hideHeader) {
    <cf-text size="sm" touchSize="sm" weight="500">
      {{ "participants_count" | translate: { count: totalParticipants.toString() } }}
    </cf-text>
  }
  @if (!hideParticipants) {
    @for (participant of participants; track participant.name) {
      <div class="tw:flex tw:flex-wrap tw:mt-2">
        @if (participant.name) {
          @switch (role) {
            @case (ERole.ORGANIZER) {
              <cf-text class="tw:mr-1" className="text-cut text-break max-1" size="sm" weight="500">
                {{ participant.name }}
              </cf-text>
              <cf-text className="text-cut text-break max-1 me-1" size="sm" color="grey-60">
                <ng-container
                  *ngTemplateOutlet="participantRole; context: { $implicit: participant.role }"
                ></ng-container>
              </cf-text>

              <br />

              <cf-text className="text-cut text-break max-1" size="sm" color="grey-60" [matTooltip]="participant.email">
                {{ participant.email }}
              </cf-text>
            }
            @case (ERole.BOOKER) {
              <cf-text class="tw:mr-1" className="text-cut text-break max-1" size="sm" weight="500">
                {{ participant.name }}
              </cf-text>

              <cf-text className="text-cut text-break max-1" size="sm" color="grey-60">
                <ng-container
                  *ngTemplateOutlet="participantRole; context: { $implicit: participant.role }"
                ></ng-container>
              </cf-text>

              @if (participant.email) {
                @if (participant.role === ERole.GUEST || participant.role === ERole.BOOKER) {
                  <cf-text
                    className="text-cut text-break max-1"
                    size="sm"
                    color="grey-60"
                    [matTooltip]="participant.email"
                  >
                    ({{ participant.email }})
                  </cf-text>
                }
              }
            }
            @default {
              <cf-text class="tw:mr-1" className="text-cut text-break max-1" size="sm" weight="500">
                {{ participant.name }}
              </cf-text>

              @if (participant.email) {
                <cf-text
                  className="text-cut text-break max-1"
                  size="sm"
                  color="grey-60"
                  [matTooltip]="participant.email"
                >
                  ({{ participant.email }})
                </cf-text>
              }
            }
          }
        } @else {
          <cf-text
            className="text-cut text-break max-1"
            size="sm"
            weight="500"
            class="tw:mr-1"
            [matTooltip]="participant.email"
          >
            {{ participant.email }}
          </cf-text>
          <cf-text className="text-cut text-break max-1" size="sm" color="grey-60">
            <ng-container *ngTemplateOutlet="participantRole; context: { $implicit: participant.role }"></ng-container>
          </cf-text>
        }
      </div>
    }
  }
</div>
<ng-template #participantRole let-role>
  @switch (role) {
    @case (ERole.ORGANIZER) {
      {{ "role.ORGANIZER" | translate }}
    }
    @case (ERole.BOOKER) {
      {{ "role.BOOKER" | translate }}
    }
    @case (ERole.GUEST) {
      {{ "role.GUEST" | translate }}
    }
    @default {
      {{ "role.ATTENDEE" | translate }}
    }
  }
</ng-template>
